import { render } from "./EntrancePunjabi.vue?vue&type=template&id=26a6e42b&scoped=true"
import script from "./EntrancePunjabi.vue?vue&type=script&lang=js"
export * from "./EntrancePunjabi.vue?vue&type=script&lang=js"

import "./EntrancePunjabi.vue?vue&type=style&index=0&id=26a6e42b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a6e42b"]])

export default __exports__